
<template>
    <el-dialog
        title="用户详情"
        width="550px"
        v-model="data.dialogTableVisible"
    >
        <el-form label-width="100px">
            <el-row>
                <el-col :span="12">
                    <el-form-item :label="`${userTypeInfo[currentData.userType]}姓名：`">
                        {{data.formLabelAlign.name}}
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item :label="`${userTypeInfo[currentData.userType]}手机号：`">
                        {{data.formLabelAlign.phone}}
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="所属停车场：">
                        {{data.formLabelAlign.parkingName}}
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="余额：">
                        {{data.formLabelAlign.totalProce}}
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="累计充值：">
                        {{data.formLabelAlign.totalRecharge || '0.00'}}
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="累计消费：">
                        {{data.formLabelAlign.totalConsume || '0.00'}}
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="累计赠送：">
                        {{data.formLabelAlign.totalGift || '0.00'}}
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="退款金额：">
                        {{data.formLabelAlign.refundAmount || '0.00'}}
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>

        <footer class="tac" style="margin-top: 50px">
            <el-button @click="showTransactionDetail" type="info">交易详情</el-button>
            <el-button @click="handleCancle">取消</el-button>
            <el-button type="primary" @click="handleSave">确定</el-button>
        </footer>
    </el-dialog>

    <transaction-detail
        :visible="transactionDialogVisible"
        :user-id="currentData.id"
        @update:visible="transactionDialogVisible = $event"
    />
</template>

<script>import { defineComponent, inject, reactive, ref } from "vue";
import {
    apiUserInsert,
    apiUserInfoUpdate,
    apiUserParkingLotList,
    apiGetUserDetail // 添加获取用户详情的API
} from "@/api/requestApis.js";
import { isMobile } from "@/api/utils.js";
import { ElMessage } from "element-plus";
import TransactionDetail from './transaction-detail.vue';

export default defineComponent({
    components: {
        TransactionDetail
    },
    props: {
        currentData: {
            type: Object,
            default() {
                return {};
            },
        },
    },
    setup(props) {
        const userTypeInfo = inject("userTypeInfo");
        const handleUpdateTable = inject("handleUpdateTable");

        const data = reactive({
            parkingName: "",
            dialogTableVisible: false,
            formLabelAlign: {
                name: "",
                parkingLotId: "",
                phone: "",
                deposit: "",
                giftAmount: "",
                totalProce: "",
                totalRecharge: "",
                totalConsume: "",
                totalGift: "",
                refundAmount: ""
            },
            // 添加统计信息字段
        });

        const transactionDialogVisible = ref(false);

        const handleReset = () => {
            Object.keys(data.formLabelAlign).forEach((key) => {
                data.formLabelAlign[key] = "";
            });
            // 重置统计信息
            data.totalRecharge = "0.00";
            data.totalConsume = "0.00";
            data.totalGift = "0.00";
            data.refundAmount = "0.00";
        };

        const handleSetDefaultVal = async () => {

            // 获取用户详细信息包括统计数据
            if (props.currentData.id) {
                try {
                    const res = await apiGetUserDetail({ id: props.currentData.id });
                    if (res) {
                        console.log(res)
                        data.formLabelAlign.name = props.currentData.name;
                        data.formLabelAlign.phone = props.currentData.phone;
                        data.formLabelAlign.totalRecharge = res.totalRecharge || "0.00";
                        data.formLabelAlign.totalConsume = res.totalConsume || "0.00";
                        data.formLabelAlign.totalGift = res.totalGift || "0.00";
                        data.formLabelAlign.refundAmount = res.refundAmount || "0.00";
                        data.formLabelAlign.deposit = res.deposit || "0.00";
                        data.formLabelAlign.giftAmount = res.giftAmount || "0.00";
                        data.formLabelAlign.parkingName = res.parkingName || "";
                        data.formLabelAlign.totalProce = res.deposit + res.giftAmount
                    }
                } catch (error) {
                    ElMessage.error("获取用户统计信息失败");
                }
            }
        };

        const handleToggle = (val) => {
            if (val) {
                setTimeout(() => {
                    handleSetDefaultVal();
                }, 10);
            }
            data.dialogTableVisible = val;
        };

        const handleSave = async () => {
            if (
                !data.formLabelAlign.name ||
                !data.formLabelAlign.parkingLotId ||
                !data.formLabelAlign.phone
            ) {
                ElMessage.warning("请填写信息");
                return;
            }
            if (!isMobile(data.formLabelAlign.phone)) {
                ElMessage.warning("手机号错误");
                return;
            }
            if (props.scene === "add") {
                await apiUserInsert({
                    ...data.formLabelAlign,
                    userType: props.currentData.userType,
                });
            }
            if (props.scene === "edit") {
                await apiUserInfoUpdate({
                    ...data.formLabelAlign,
                    userType: props.currentData.userType,
                    id: props.currentData.id,
                });
            }
            handleToggle(false);
            handleReset();
            handleUpdateTable();
        };

        const handleCancle = () => {
            handleToggle(false);
            handleReset();
        };

        const querySearchAsync = async (val, cb) => {
            const res = await apiUserParkingLotList({
                name: val,
            });
            const list = res.map((item) => {
                return {
                    value: item.name,
                    ...item,
                };
            });
            cb(list);
        };

        const handleSelect = (val) => {
            data.formLabelAlign.parkingLotId = val.id;
        };

        const showTransactionDetail = () => {
            if (!props.currentData.id) {
                ElMessage.warning("无法查看交易详情，缺少用户ID");
                return;
            }
            transactionDialogVisible.value = true;
        };

        return {
            userTypeInfo,
            querySearchAsync,
            handleSelect,
            handleCancle,
            handleSave,
            handleToggle,
            data,
            transactionDialogVisible,
            showTransactionDetail
        };
    },
});
</script>

<style scoped></style>
